import FormInput from './FormInput';
import FormEntry from './FormEntry';
import { useSessions } from '../hooks/useSessions';

interface ParentSessionSelectorProps {
  showDropdown: boolean;
  className?: string;
  currentSessionId?: string;
}

export default function ParentSessionSelector({
  showDropdown,
  className = 'cr-mb-4',
  currentSessionId,
}: ParentSessionSelectorProps) {
  // Fetch existing sessions to use as potential parent sessions
  const { data: sessions } = useSessions();

  if (!showDropdown) return null;

  const containerClasses = `cr-flex cr-flex-col cr-rounded-lg cr-bg-white cr-px-4 cr-pb-4 cr-pt-3 cr-text-center
    cr-shadow-md md:cr-w-[640px] md:cr-text-left ${className}`;

  return (
    <div className={containerClasses}>
      <FormEntry label="Parent Session">
        <FormInput
          fieldName="parent_id"
          options={Array.from(sessions || []).filter(
            (session: any) => session.id !== currentSessionId && Number(session.analysis_type) === 1050,
          )}
          optionLabelFn={(session: any) => `${session.date || new Date(session.created_at).toLocaleDateString()} -
           ${session.description || session.name || 'Unnamed Session'}`}
          emptyOption="Select Parent Session (Optional)"
          customClass="cr-w-full md:cr-w-[320px]"
        />
      </FormEntry>
      <div className="cr-mt-2 cr-text-sm cr-text-gray-600">
        <strong>Note:</strong> Only &quot;Rolling Resistance - Reference&quot; sessions can be selected as parent
        sessions. If you haven&apos;t created one yet, create a reference session first.
      </div>
    </div>
  );
}
